import { IEvent } from "modules/event/types";
import { sendGetRequest } from "services/apiService";

export const getRequestURL = (
  companyId?: string | null,
  query?: string,
  limitQueryToCompanyEvents?: boolean,
) =>
  companyId
    ? `/event/discovery/${companyId}?query=${query}&limitQueryToCompanyEvents=${Boolean(
        limitQueryToCompanyEvents,
      )}`
    : `/event/discovery?query=${query}`;

export const getDiscoverableEvents = (
  companyId?: string | null,
  query?: string,
  limitQueryToCompanyEvents?: boolean,
): Promise<
  APIResponse<{
    events: IEvent[];
  }>
> => sendGetRequest(getRequestURL(companyId, query, limitQueryToCompanyEvents));
